import React from 'react'
import GradientBgLg from '../assets/images/gradient_bg_lg.jpg'

const FeaturesHero = ({ content = {} }) => {
  const {
    badge = 'Feedback',
    title = 'Collect, Understand, and Act on Customer Feedback',
    description = 'Stop guessing what customers want. Capture real feedback across channels and turn insights into action with Clientshot.',
    primaryCtaLabel = 'Book a demo',
    primaryCtaHref = 'https://calendly.com/clientshot1/demo-call',
    secondaryCtaLabel = 'Start free',
    secondaryCtaHref = 'https://app.clientshot.com/sign-up',
    videoUrl = 'https://www.youtube.com/embed/_QmyvFOasGk',
    mediaImage,
  } = content

  return (
    <div>
        <section
          className="relative bg-cover bg-center bg-no-repeat text-white"
          style={{
            backgroundColor: '#8A6CC8',
            backgroundImage: `url(${GradientBgLg})`,
          }}
        >
      {/* Background Shape */}
      <div className="absolute bottom-0 left-0 w-full h-24 bg-white rounded-t-[40%]"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12 py-20 lg:py-28">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          
          {/* LEFT CONTENT */}
          <div
            data-aos="fade-up"
            className="space-y-6 text-center lg:text-left"
          >
            <p className="text-sm uppercase tracking-widest text-purple-200">
              {badge}
            </p>

            <h3 className="heading-three text-3xl sm:text-4xl md:text-5xl font-bold ">
              {title}
            </h3>

            <p className="text-base sm:text-lg text-purple-100 max-w-xl mx-auto lg:mx-0">
              {description}
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start pt-4">
              <a href={primaryCtaHref} className="btn btn-alt px-6 py-3 rounded-xl bg-black text-white font-medium transition shadow-lg">
                {primaryCtaLabel}
              </a>

              <a href={secondaryCtaHref} className="btn btn-secondary w-full md:w-max px-6 py-3 rounded-xl bg-white text-black font-medium hover:bg-gray-100 transition shadow-lg">
                {secondaryCtaLabel}
              </a>
            </div>
          </div>

          {/* RIGHT VIDEO CARD */}
          <div
            data-aos="fade-left"
            data-aos-delay="200"
            className="relative w-full max-w-[330px] sm:max-w-full mx-auto"
          >
            <div className="relative w-full max-w-[330px] sm:max-w-full mx-auto aspect-video min-h-[240px] sm:min-h-[300px] lg:min-h-[360px] overflow-hidden rounded-2xl">
              {mediaImage?.src ? (
                <img
                  src={mediaImage.src}
                  alt={mediaImage.alt || 'Feature hero preview'}
                  className="w-full h-full object-contain scale-105"
                />
              ) : (
                <iframe
                  className="w-full h-full rounded-2xl"
                  src={videoUrl}
                  title="Dummy demo video"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                />
              )}
            </div>

            {/* Subtle Shadow Layer */}
            <div className="hidden sm:block absolute -bottom-6 left-6 right-6 h-10 bg-purple-900/40 blur-2xl rounded-full"></div>
          </div>

        </div>
      </div>
    </section>
    </div>
  )
}

export default FeaturesHero
